import React, { useState, useRef, useEffect, useCallback } from "react";
import { Box, Button, DialogTitle, Divider, Tooltip } from "@mui/material";
import  CloseIcon  from "@mui/icons-material/Close";
import OpenInFullIcon from '@mui/icons-material/OpenInFull';


let sizeCursor = 0

const sizes = [
    {h: 500, w: 500},
    {h: 600, w: 600},
    {h: 700, w: 700}
]

const DraggableBox = ({show, handleClose, title, children, sx, className, x = null, y = null, header, actions}) => {
  const [pos, setPos] = useState({x: 100, y: 100});
  const [dimension, setDimension] = useState(sizes[sizeCursor % sizes.length]) 
  const dragData = useRef({ dragging: false, offsetX: 0, offsetY: 0 });
  const box = useRef()

    const resize = useCallback(()=>{
        sizeCursor++
        const cursor = sizeCursor % sizes.length
        setDimension(sizes[cursor])
    }, [])

  useEffect(() => {

    const rect = box.current.getBoundingClientRect()
    setPos({x: rect.x+x, y: rect.y+y})

    const onMouseMove = (e) => {
      if (!dragData.current.dragging) return;
      setPos({
        x: e.clientX - dragData.current.offsetX,
        y: e.clientY - dragData.current.offsetY,
      });
    };
        
    const onMouseUp = () => {
      dragData.current.dragging = false;
    };

    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };
  }, []);

  useEffect(() => {
    const onTouchMove = (e) => {
      if (!dragData.current.dragging) return;
      const touch = e.touches[0];
      setPos({
        x: touch.clientX - dragData.current.offsetX,
        y: touch.clientY - dragData.current.offsetY,
      });
    };

    const onTouchEnd = () => {
      dragData.current.dragging = false;
    };

    window.addEventListener("touchmove", onTouchMove, { passive: false });
    window.addEventListener("touchend", onTouchEnd);
    window.addEventListener("touchcancel", onTouchEnd);
    return () => {
      window.removeEventListener("touchmove", onTouchMove);
      window.removeEventListener("touchend", onTouchEnd);
      window.removeEventListener("touchcancel", onTouchEnd);
    };
  }, []);

  const startMouseDrag = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    dragData.current.dragging = true;
    dragData.current.offsetX = e.clientX - rect.left;
    dragData.current.offsetY = e.clientY - rect.top;
  };

  const startTouchDrag = (e) => {
    const touch = e.touches[0];
    const rect = e.currentTarget.getBoundingClientRect();
    dragData.current.dragging = true;
    dragData.current.offsetX = touch.clientX - rect.left;
    dragData.current.offsetY = touch.clientY - rect.top;
  };

  return (
    <Box ref={box} position='relative' zIndex={2}>
        <Box position='absolute' display={show ? 'block': 'none'}>
            <div
            onMouseDown={startMouseDrag}
            onTouchStart={startTouchDrag}
            style={{
                position: "fixed",
                left: pos.x,
                top: pos.y,
                height: dimension.h,
                width: dimension.w,
                userSelect: "none",
                touchAction: "none", // important to allow custom touch drag
                cursor: "grab",
                ...sx
            }}
            className={className}
            >
                {!header? <Box className='draggable-box-header'>
                            <DialogTitle id="customized-dialog-title" className={'group-flexbox'} sx={{padding: '0.25rem 0.5rem'}}>
                              <span>{title}</span> <Box>
                      <Tooltip title='Alternar tamanho'><Button sx={{ 'minWidth': '2rem', 'padding': '0' }} onClick={resize}><OpenInFullIcon className='action-button'/></Button></Tooltip>
                      <Tooltip title='Fechar'><Button sx={{ 'minWidth': '2rem', 'padding': '0' }} onClick={handleClose}><CloseIcon className='action-button delete'/></Button></Tooltip>
                    </Box>
                            </DialogTitle>                    
                </Box> : header}
                <Divider />
                <Box className='draggable-box-content'>
                    {children}
                </Box>
                {!actions ? <Box className='draggable-box-actions'>

                </Box> : actions}
            </div>
        </Box>
    </Box>
  );
}

export default DraggableBox